import { render, staticRenderFns } from "./Table361GeneralCheckup.vue?vue&type=template&id=70611379&scoped=true"
import script from "./Table361GeneralCheckup.vue?vue&type=script&lang=js"
export * from "./Table361GeneralCheckup.vue?vue&type=script&lang=js"
import style0 from "./Table361GeneralCheckup.vue?vue&type=style&index=0&id=70611379&prod&lang=css"
import style1 from "./Table361GeneralCheckup.vue?vue&type=style&index=1&id=70611379&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70611379",
  null
  
)

export default component.exports